/**
 * Підсвітка блоків коду.
 *
 * highlight.js (core + 9 мов) важить чимало й потрібен лише в статтях
 * блогу з кодом. Тому тут — лише дешева перевірка DOM, а сама бібліотека
 * тягнеться динамічним import() окремим чанком і ТІЛЬКИ якщо на сторінці
 * реально є блоки коду. На головній/лендингах вона не вантажиться взагалі
 * — це прибирає її парсинг і виконання з Total Blocking Time.
 */
const SELECTOR = 'pre.wp-block-code, .post-content pre';

export default async function code() {
  if (!document.querySelector(SELECTOR)) return;

  const { default: highlight } = await import(
    /* webpackChunkName: "hljs" */ './codeHighlight.js'
  );
  highlight();
}
